<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
  export default {
    name: 'CrewBookings',
  };
</script>

<style scoped>

</style>